import { Button, Form } from "rsuite";
import { ForgetPasswordForm } from "./forgetPassForm.component";
import {
  ForgetPasswordDefaultValues,
  ForgetPasswordFormType,
  ForgetPasswordFormSchema,
} from "../../models/forms/forgetPasswordForm";
import { useState } from "react";
import { Link } from "react-router-dom";
import { AppRoutesUI } from "../../config/appRoutes";
import { ApiAuth } from "../../core/apis/auth";
import { showErrorToast, showSuccessToast } from "../generic/toast.component";

export const ForgetPassword = () => {
  const [formValue, setFormValue] = useState<ForgetPasswordFormType>(
    ForgetPasswordDefaultValues
  );
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const handleSave = async (checked: boolean) => {
    if (!checked) return;
    setIsLoading(true);
    try {
      await ApiAuth.forgotPassword(formValue.userId || "");
      showSuccessToast(
        "Please Check Your Email For Password Reset Instructions."
      );
    } catch (e: any) {
      showErrorToast(e.response?.data?.Message || e.message);
    }
    setFormValue(ForgetPasswordDefaultValues);
    setIsLoading(false);
  };
  return (
    <div className="d-flex flex-column px-xl-5 m-xl-4 px-sm-0">
      <Form
        formValue={formValue}
        onChange={setFormValue}
        model={ForgetPasswordFormSchema}
        onSubmit={handleSave}
        fluid
      >
        <ForgetPasswordForm />
        <div className="d-flex justify-content-end align-items-center mb-3 mt-4">
          <Link to={AppRoutesUI.Auth.Login.Path()}>
            <Button
              size="sm"
              appearance="primary"
              className="form-cancel-buttons fw-bold px-3"
            >
              Back to Login
            </Button>
          </Link>
          <Button
            size="sm"
            appearance="primary"
            type="submit"
            loading={isLoading}
            className="form-buttons ms-3 fw-bold px-3"
          >
            Submit
          </Button>
        </div>
      </Form>
    </div>
  );
};
